import {SubmitDataFilters} from 'src/app/submit-data/models/submit-data.model';

export class UpdateSubmitDataFilters {
  static readonly type = '[SubmitData] Update filters';

  constructor(public filters: SubmitDataFilters) {
  }
}

/**
 * Fetch a page of results for the filters in state, unless that page is already there.  Pass force to bypass the
 * cache, such as when the filters have changed.
 */
export class SearchSubmitData {
  static readonly type = '[SubmitData] Search';

  constructor(
    public page: number = 1,
    public force: boolean = false,
  ) {
  }
}

export class ClearSubmitData {
  static readonly type = '[SubmitData] Clear';
}
